declare var window: any
const message = (text: string) => {
  const tips = document.getElementById('tips');
  if (tips) {
    tips.remove();
  }

  const template = `<div class="toolTips"  id='tips'> ${text} </div>`
  let tempNode = document.createElement('div');
  tempNode.innerHTML = template;
  const app = document.getElementById('root');
  if(app)
  app.appendChild(tempNode);
  setTimeout(() => {
    tempNode.remove();
  }, 1500)
}

const getParameterByName = (name:string) => {
  name = name.replace(/[\\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  const results = regex.exec(window.location.href);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export {
  message,
  getParameterByName
}